import { useSettingsDoc } from "@/hooks/settings/useSettingsDoc";
import { useGraphSettings } from "@/hooks/settings/useGraphSettings";
import { useBrandingSettings, useSmtpSettings, useSyncSettings } from "@/hooks/settings/useSectionSettings";
import { useProfileSave } from "@/hooks/settings/useProfileSave";

/** Composes one hook per settings category for the Configuración screen. */
export function useSettings() {
  const { settings, load } = useSettingsDoc();
  return {
    settings,
    load,
    ...useGraphSettings(settings, load),
    ...useSmtpSettings(settings, load),
    ...useBrandingSettings(settings, load),
    ...useSyncSettings(settings, load),
    saveProfile: useProfileSave(),
  };
}
